import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PropertyManagement from "@/pages/PropertyManagement";
import PricingManagement from "@/pages/PricingManagement";
import BookingsManagement from "@/pages/BookingsManagement";
import UserManagement from "@/pages/UserManagement";
import PaymentSuccess from "@/pages/PaymentSuccess";
import DiscountCodesManagement from "@/pages/DiscountCodesManagement";
import EmailSettings from "@/pages/EmailSettings";
import PaymentSettings from "@/pages/PaymentSettings";
import CalendarSync from "@/pages/CalendarSync";
import DocumentsManagement from "@/pages/DocumentsManagement";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import "@/index.css";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/property"
                element={
                  <ProtectedRoute>
                    <PropertyManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/pricing"
                element={
                  <ProtectedRoute>
                    <PricingManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/bookings"
                element={
                  <ProtectedRoute>
                    <BookingsManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users"
                element={
                  <ProtectedRoute>
                    <UserManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/discount-codes"
                element={
                  <ProtectedRoute>
                    <DiscountCodesManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/email-settings"
                element={
                  <ProtectedRoute>
                    <EmailSettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payment-settings"
                element={
                  <ProtectedRoute>
                    <PaymentSettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/calendar-sync"
                element={
                  <ProtectedRoute>
                    <CalendarSync />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/documents"
                element={
                  <ProtectedRoute>
                    <DocumentsManagement />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Toaster />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;